.button {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: var(--color-easil-blue);
  height: 40px;
  border-radius: 8px;
  border: solid 1px var(--color-easil-blue);
  padding: 8px 24px 8px 24px;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.5;
  cursor: pointer;
}

.button[data-disabled="true"] {
  border: solid 1px var(--color-easil-gray-x-light);
  background-color: var(--color-easil-gray-x-light);
  color: white;
  cursor: not-allowed;
}

.button[data-is-full-width="true"],
.button[data-is-extra-wide="true"] {
  width: 100%;
  padding: 8px 32px 8px 32px;
}

.button[data-is-hoverable="true"]:hover {
  opacity: 0.9;
}

.button:focus {
  outline: none;
}

.button:focus-visible {
  outline: 2px solid var(--color-easil-blue);
  outline-offset: 2px;
  box-shadow: 0 0 0 4px rgba(0, 120, 212, 0.2);
}

.gray {
  border: solid 1px var(--color-easil-gray-x-light);
  background-color: white;
  color: var(--color-easil-gray-x-dark);
}

.grayBackgroundWhiteFont {
  background-color: #a1a7ab;
  color: white;
  border: solid 1px #a1a7ab;
}

.grayBackgroundXDarkGrayFont {
  background-color: #e5e8eb;
  color: var(--color-easil-gray-x-dark);
  border: 1px solid #e5e8eb;
}

.grayBackgroundXDarkGrayFont:hover {
  background-color: var(--color-easil-gray-background-x-dark-gray-font-hover);
  color: var(--color-easil-gray-x-dark);
  border: 1px solid var(--color-easil-gray-background-x-dark-gray-font-hover);
}

.grayBackgroundXDarkGrayFontDisabled {
  color: var(--color-easil-gray-x-dark) !important;
  border: 1px solid #e5e8eb !important;
  background-color: #e5e8eb !important;
  cursor: not-allowed;
  pointer-events: none;
  opacity: 0.5;
}

.grayBorderOnly {
  border: solid 1px var(--color-easil-gray-x-light);
  background-color: transparent;
  color: var(--color-easil-black);
}

.whiteBorderWhiteFont {
  border: solid 2px white;
  background-color: transparent;
  color: white;
}

.whiteBorderWhiteFontWithTransition {
  border: solid 2px white;
  background-color: rgba(255, 255, 255, 0);
  color: white;
  transition: color 100ms ease;
  transition: background-color 100ms ease;
}

.whiteBorderWhiteFontWithTransition:hover {
  border: solid 2px white;
  background-color: rgba(255, 255, 255, 1);
  color: var(--color-easil-black);
}

.xLightGrayBorderWhiteFont {
  border: solid 1px var(--color-easil-gray-x-light);
  background-color: transparent;
  color: white;
}

.xLightGrayBorderXDarkGrayFont {
  border: solid 1px var(--color-easil-gray-x-light);
  background-color: transparent;
  color: var(--color-easil-gray-x-dark);
}

.grayBorderWhiteFont {
  border: solid 1px #56585c;
  background-color: transparent;
  color: white;
}

.grayBorderWhiteFontDisabled {
  border: solid 1px #56585c !important;
  background-color: transparent !important;
  color: white !important;
  opacity: 0.48;
}

.blue {
  border: solid 1px white;
  background-color: var(--color-easil-blue);
  color: white;
}

.blueTall {
  height: 40px;
  border: solid 1px white;
  background-color: var(--color-easil-blue);
  color: white;
  font-size: 15px;
  font-weight: 500;
  line-height: 1.6;
}

.blueSolid {
  border: solid 1px var(--color-easil-blue);
  background-color: var(--color-easil-blue);
  color: white;
}

.blueSolid:hover {
  background-color: var(--color-easil-blue-solid-hover);
  border: solid 1px var(--color-easil-blue-solid-hover);
}

.blueSolidWithTransition {
  border: none;
  background-color: var(--color-easil-blue-deep-with-alpha);
  color: white;
  transition: background-color 100ms ease;
}

.blueDarkSolid {
  border: solid 1px var(--color-easil-blue-dark);
  background-color: var(--color-easil-blue-dark);
  color: white;
}

.blueSolidWithTransition:hover {
  background-color: var(--color-easil-blue-deep-with-alpha-hover);
}

.greenDarkSolidWithTransition {
  border: none;
  background-color: var(--color-easil-green-dark-alpha);
  color: white;
  line-height: 1;
  transition: background-color 100ms ease;
}

.greenDarkSolidWithTransition:hover {
  background-color: var(--color-easil-green-dark-alpha-hover);
}

.blueDeepNoBackgroundNoBorder {
  color: var(--color-easil-blue-deep);
  border: none;
}

.blueSolidNoBackgroundNoBorder {
  background-color: rgba(0, 0, 0, 0);
  color: var(--color-easil-blue);
  border: none;
}

.blueSolidNoBackgroundNoBorder:hover {
  background-color: #e5e8eb;
}

.blueOutline {
  border: solid 1px var(--color-easil-blue);
  background-color: white;
  color: var(--color-easil-blue);
}

.whiteSolidBlueFontNoBorder {
  border: none;
  background-color: white;
  color: var(--color-easil-blue);
}

.royalBlue {
  border: solid 1px white;
  background-color: var(--color-easil-royal-blue);
  color: white;
}

.royalBlueSolid {
  border: solid 1px var(--color-easil-royal-blue);
  background-color: var(--color-easil-royal-blue);
  color: white;
}

.royalBlueOutline {
  border: solid 1px var(--color-easil-royal-blue);
  background-color: white;
  color: var(--color-easil-royal-blue);
}

.royalBlueWithTransition {
  border: none;
  background-color: var(--color-easil-royal-blue);
  color: white;
  line-height: 1;
  transition: background-color 100ms ease;
}

.royalBlueWithTransition:hover {
  background-color: var(--color-easil-royal-blue-hover);
}

.blackSolid {
  border: solid 1px var(--color-easil-black-light);
  background-color: var(--color-easil-black-light);
  color: white;
}

.blueLight {
  border: solid 1px var(--color-easil-blue);
  background-color: white;
  color: var(--color-easil-blue);
  transition: 300ms all ease-in-out;
}

.blueLight:hover {
  background-color: var(--color-easil-blue);
  color: #fff;
}

.red {
  border: solid 1px white;
  background-color: var(--color-easil-red);
  color: white;
}

.redSolid {
  border: solid 1px var(--color-easil-red);
  background-color: var(--color-easil-red);
  color: white;
}

.redSolid:hover {
  border: solid 1px var(--color-easil-red-solid-hover);
  background-color: var(--color-easil-red-solid-hover);
}

.redLight {
  border: solid 1px var(--color-easil-red);
  background-color: white;
  color: var(--color-easil-red);
}

.white {
  border: solid 1px white;
  background-color: #fff;
  color: var(--color-easil-black);
}

.greenSolid {
  border: solid 1px var(--color-easil-green);
  background-color: var(--color-easil-green);
  color: white;
}

.greenSolid:hover {
  border: solid 1px var(--color-easil-green-solid-hover);
  background-color: var(--color-easil-green-solid-hover);
}

.greenMidSolid {
  border: solid 1px var(--color-easil-green-mid);
  background-color: var(--color-easil-green-mid);
  color: white;
}

.actionbar {
  height: 32px;
  border: solid 1px var(--color-easil-gray-x-light);
  background-color: transparent;
  color: var(--color-easil-gray-x-dark);
  width: 100%;
}

.actionbarNarrow {
  height: 32px;
  border: solid 1px var(--color-easil-gray-x-light);
  background-color: transparent;
  color: var(--color-easil-gray-x-dark);
  padding: 0px 8px 0px 8px;
}

.actionbarNarrow[data-is-active="true"] {
  border: solid 1px var(--color-easil-gray-x-dark);
}

.actionbar[data-disabled="true"] {
  border: solid 1px var(--color-easil-gray-x-light);
  background-color: transparent;
  color: var(--color-easil-gray-x-light);
  cursor: not-allowed;
}

.canvas {
  height: 40px;
  border-radius: 8px;
  border: solid 1px #c5c8ca;
  background-color: transparent;
  line-height: 2.86;
  letter-spacing: normal;
  color: #a1a6aa;
  box-sizing: content-box;
  width: auto !important;
}

.disabledBlue[data-disabled="true"] {
  background-color: var(--color-easil-blue);
  border-color: var(--color-easil-blue);
  opacity: 1;
}

.loginSignupButtons {
  padding: 0 24px !important;
  height: 48px;
}

.facebook {
  composes: loginSignupButtons;
  color: #ffffff;
  background-color: #1877f2;
  border-color: #1877f2;
}

.facebook:hover {
  background-color: var(--color-easil-blue-solid-hover);
  border-color: var(--color-easil-blue-solid-hover);
}

.google {
  composes: loginSignupButtons;
  color: rgba(0, 0, 0, 0.54);
  background-color: #ffffff;
  border: none;
  box-shadow:
    0 1px 1px 0 rgba(0, 0, 0, 0.24),
    0 0 1px 0 rgba(0, 0, 0, 0.12);
}

.google:hover {
  background-color: var(--color-hover-color);
}

.NoBackgroundNoBorder {
  background-color: rgba(0, 0, 0, 0);
  border: none;
}

.greyFontBorderTransparentBackground {
  background-color: rgba(0, 0, 0, 0);
  border: 1px solid #ffffff;
  color: #ffffff;
}

/*
  Standard more button styling
  MoreButton component should be preferred to directly referencing this style
*/
.loadMoreButton {
  min-width: 211px !important;
  width: auto !important;
  font-family: Roboto;
  font-size: 15px;
  font-weight: 500;
  line-height: 1.5;
  color: white;
  justify-content: center !important;
  margin-top: 16px;
  background-color: #3184fc;
  transition: background-color 0.15s ease;
}

.loadMoreButton:hover {
  background-color: #2e7def;
}
